// start:ng42.barrel
export * from './number-status.component';
// end:ng42.barrel




// WEBPACK FOOTER //
// ./src/main/webapp/stay-mgmt/app/components/number-status/index.ts